import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAIL,
  CLEAR_NOTIFICATIONS,
  LOAD_MORE_NOTIFICATIONS,
  LOAD_MORE_NOTIFICATIONS_SUCCESS,
  LOAD_MORE_NOTIFICATIONS_FAIL,
  TOGGLE_NOTIFICATION_READ_UNREAD,
  TOGGLE_NOTIFICATION_READ_UNREAD_SUCCESS,
  TOGGLE_NOTIFICATION_READ_UNREAD_FAIL,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  notifications: [],
  newNotifications: [],
  totalNotificationCount: 0,
  newNotificationCount: 0,
  unreadNotificationCount: 0,
  isLoading: false,
  isLoadingMore: false,
  error: null,
  currentStartIndex: 0,
  hasMoreNotifications: true,
  
  // Action success states
  toggleSuccess: false,
  deleteSuccess: false,
}

const notifications = (state = INIT_STATE, action) => {
  switch (action.type) {
    // GET NOTIFICATIONS
    case GET_NOTIFICATIONS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }

    case GET_NOTIFICATIONS_SUCCESS:
      const { 
        totalNotificationCount, 
        newNotificationCount, 
        unreadNotificationCount,
        newNotifications = [],
        notifications: notificationsList = []
      } = action.payload

      // Combine new notifications and regular notifications for display
      const safeNewNotifications = newNotifications || []
      const allNotifications = [...safeNewNotifications, ...notificationsList]
      const totalCount = parseInt(totalNotificationCount) || 0
      
      return {
        ...state,
        notifications: allNotifications,
        newNotifications: safeNewNotifications,
        totalNotificationCount: totalCount,
        newNotificationCount: parseInt(newNotificationCount) || 0,
        unreadNotificationCount: parseInt(unreadNotificationCount) || 0,
        isLoading: false,
        error: null,
        currentStartIndex: allNotifications.length,
        hasMoreNotifications: allNotifications.length < totalCount,
      }

    case GET_NOTIFICATIONS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        notifications: [],
        newNotifications: [],
      }

    // LOAD MORE NOTIFICATIONS
    case LOAD_MORE_NOTIFICATIONS:
      return {
        ...state,
        isLoadingMore: true,
        error: null,
      }

    case LOAD_MORE_NOTIFICATIONS_SUCCESS:
      const moreNotifications = action.payload.notifications || []
      const updatedNotifications = [...state.notifications, ...moreNotifications]
      
      return {
        ...state,
        notifications: updatedNotifications,
        newNotifications: [], // Clear new notifications after load more (as backend clears them)
        isLoadingMore: false,
        error: null,
        currentStartIndex: updatedNotifications.length,
        hasMoreNotifications: updatedNotifications.length < state.totalNotificationCount,
      }

    case LOAD_MORE_NOTIFICATIONS_FAIL:
      return {
        ...state,
        isLoadingMore: false,
        error: action.payload,
      }

    // TOGGLE NOTIFICATION READ/UNREAD
    case TOGGLE_NOTIFICATION_READ_UNREAD:
      return {
        ...state,
        toggleSuccess: false,
        error: null,
      }

    case TOGGLE_NOTIFICATION_READ_UNREAD_SUCCESS:
      const { notificationIDs } = action.payload
      return {
        ...state,
        notifications: state.notifications.map(notification => {
          if (notificationIDs.includes(notification.notificationID.toString())) {
            const wasUnread = notification.hasBeenRead === "false"
            return { ...notification, hasBeenRead: wasUnread ? "true" : "false" }
          }
          return notification
        }),
        newNotifications: (state.newNotifications || []).filter(
          notification => !notificationIDs.includes(notification.notificationID.toString())
        ),
        unreadNotificationCount: state.notifications.reduce((count, notification) => {
          if (notificationIDs.includes(notification.notificationID.toString())) {
            return notification.hasBeenRead === "false" ? count - 1 : count + 1
          }
          return count
        }, state.unreadNotificationCount),
        newNotificationCount: Math.max(0, state.newNotificationCount - 
          (state.newNotifications || []).filter(n => 
            notificationIDs.includes(n.notificationID.toString())
          ).length
        ),
        toggleSuccess: true,
        error: null,
      }

    case TOGGLE_NOTIFICATION_READ_UNREAD_FAIL:
      return {
        ...state,
        toggleSuccess: false,
        error: action.payload,
      }

    // DELETE NOTIFICATION
    case DELETE_NOTIFICATION:
      return {
        ...state,
        deleteSuccess: false,
        error: null,
      }

    case DELETE_NOTIFICATION_SUCCESS:
      const { notificationIDs: deletedNotificationIDs } = action.payload
      const deletedNotifications = state.notifications.filter(n => 
        deletedNotificationIDs.includes(n.notificationID.toString())
      )
      const deletedUnreadCount = deletedNotifications.filter(n => n.hasBeenRead === "false").length
      const deletedNewCount = (state.newNotifications || []).filter(n => 
        deletedNotificationIDs.includes(n.notificationID.toString())
      ).length

      return {
        ...state,
        notifications: state.notifications.filter(
          notification => !deletedNotificationIDs.includes(notification.notificationID.toString())
        ),
        newNotifications: (state.newNotifications || []).filter(
          notification => !deletedNotificationIDs.includes(notification.notificationID.toString())
        ),
        totalNotificationCount: Math.max(0, state.totalNotificationCount - deletedNotificationIDs.length),
        unreadNotificationCount: Math.max(0, state.unreadNotificationCount - deletedUnreadCount),
        newNotificationCount: Math.max(0, state.newNotificationCount - deletedNewCount),
        deleteSuccess: true,
        error: null,
      }

    case DELETE_NOTIFICATION_FAIL:
      return {
        ...state,
        deleteSuccess: false,
        error: action.payload,
      }

    // CLEAR NOTIFICATIONS
    case CLEAR_NOTIFICATIONS:
      return {
        ...INIT_STATE,
      }

    default:
      return { ...state }
  }
}

export default notifications